/*eslint-disable */
// This optional code is used to register a service worker.
// register() is not called by default.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.

// To learn more about the benefits of this model and instructions on how to

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
)

export function register(config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    // The URL constructor is available in all browsers that support SW.
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href)
    if (publicUrl.origin !== window.location.origin) {
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets see https://github.com/facebook/create-react-app/issues/2374
      return
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`

      if (isLocalhost) {
        // This is running on localhost. Let's check if a service worker still exists or not.
        checkValidServiceWorker(swUrl, config)

        // Add some additional logging to localhost, pointing developers to the
        // service worker/PWA documentation.
        navigator.serviceWorker.ready.then(() => {
          console.log(
            'This web app is being served cache-first by a service '
          )
        })
      } else {
        // Is not localhost. Just register service worker
        registerValidSW(swUrl, config)
      }
    })
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then(registration => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing
        if (installingWorker === null) {
          return
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // At this point, the updated precached content has been fetched,
              // but the previous service worker will still serve the older
              // content until all client tabs are closed.
              console.log(
                'New content is available and will be used when all ' 
              )

              // Execute callback
              if (config && config.onUpdate) {
                config.onUpdate(registration)
              }
            } else {
              // At this point, everything has been precached.
              // It's the perfect time to display a
              // "Content is cached for offline use." message.
              console.log('Content is cached for offline use.')

              // Execute callback
              if (config && config.onSuccess) {
                config.onSuccess(registration)
              }
            }
          }
        }
      }
    })
    .catch(error => {
      console.error('Error during service worker registration:', error)
    })
}

function checkValidServiceWorker(swUrl, config) {
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl)
    .then(response => {
      // Ensure service worker exists, and that we really are getting a JS file.
      const contentType = response.headers.get('content-type')
      if (response.status === 404 || (contentType !== null && contentType.indexOf('javascript') === -1)) {
        // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then(registration => {
          registration.unregister().then(() => {
            window.location.reload()
          })
        })
      } else {
        // Service worker found. Proceed as normal.
        registerValidSW(swUrl, config)
      }
    })
    .catch(() => {
      console.log('No internet connection found. App is running in offline mode.')
    })
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(registration => {
      registration.unregister()
    })
  }
}

// export function registerForPushNotification(config = {}) {
//   if ("serviceWorker" in navigator) {
//     const publicUrl = new URL(window.location.origin);
//     if (!publicUrl.origin.includes(process.env.REACT_APP_UI_DOMAIN || "localhost:3200")) {
//       // Service worker won't work if PUBLIC_URL is on a different origin
//       return;
//     }

//     window.addEventListener("load", () => {
//       config.swUrl = `/service-worker.js`;

//       requestPermission(config);
//     });

//     // Listen for foreground messages
//     const firebaseConfig = {
//       apiKey: "YOUR_API_KEY",
//       authDomain: "YOUR_AUTH_DOMAIN",
//       projectId: "YOUR_PROJECT_ID",
//       storageBucket: "YOUR_STORAGE_BUCKET",
//       messagingSenderId: "YOUR_SENDER_ID",
//       appId: "YOUR_APP_ID",
//     };

//     const app = initializeApp(firebaseConfig);
//     const messaging = getMessaging(app);

//     onMessage(messaging, (payload) => {
//       console.log("Message received. ", payload);
//       const { title, body } = payload.notification || {};
//       const options = {
//         body,
//         icon: "/leadbrix.ico", // Replace with your icon path
//       };
//       navigator.serviceWorker.ready.then((registration) => {
//         registration.showNotification(title || "Notification", options);
//       });
//     });
//   }
// }

// export const requestPermission = async (config) => {
//   try {
//     // Check if the user has already granted notification permission
//     if (Notification.permission === "granted") {
//       console.log("Notification permission already granted.");
//       return;
//     }

//     if (Notification.permission === "denied") {
//       console.warn("Notification permission was denied. Cannot request again.");
//       return;
//     }

//     const registration = await navigator.serviceWorker.register(config.swUrl);
//     console.log("Service Worker registered with scope:", registration.scope);

//     // Initialize Firebase
//     const firebaseConfig = {
//       apiKey: "YOUR_API_KEY",
//       authDomain: "YOUR_AUTH_DOMAIN",
//       projectId: "YOUR_PROJECT_ID",
//       storageBucket: "YOUR_STORAGE_BUCKET",
//       messagingSenderId: "YOUR_SENDER_ID",
//       appId: "YOUR_APP_ID",
//     };

//     const app = initializeApp(firebaseConfig);
//     const messaging = getMessaging(app);

//     const permission = await Notification.requestPermission();
//     if (permission === "granted") {
//       const token = await getToken(messaging, {
//         vapidKey: "YOUR_PUBLIC_VAPID_KEY",
//       });
//       console.log("Token:", token);
//       localStorage.setItem("subscription", token);
//     } else {
//       console.warn("Notification permission not granted.");
//     }
//   } catch (error) {
//     console.error("Error during service worker registration or push setup:", error);
//   }
// };



// src/serviceWorker.js
import { initializeApp } from "firebase/app";
import { getMessaging, onMessage, getToken } from "firebase/messaging";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAHDFo_UNt_Ev52iQNTQg5y8SWMGDcfk4w",
  authDomain: "vuelix-fcm.firebaseapp.com",
  projectId: "vuelix-fcm",
  storageBucket: "vuelix-fcm.firebasestorage.app",
  messagingSenderId: "952853177127",
  appId: "1:952853177127:web:93bc835e231e6bace9ff02"
};

export const registerServiceWorker = async () => {
  if ("serviceWorker" in navigator) {
    try {
      const registration = await navigator.serviceWorker.register(
        `/firebase-messaging-sw.js`,
        { scope: '/' }
      );
      console.log("Service Worker registered: ", registration);
      return registration;
    } catch (error) {
      console.error("Service Worker registration failed: ", error);
    }
  } else {
    console.warn("Service Worker is not supported in this browser.");
  }
};

const requestNotificationPermission = async () => {
  if (Notification.permission !== 'granted') {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      console.log("Notification permission granted.");
    } else {
      console.warn("Notification permission denied.");
    }
    return permission;
  } else {
    return Notification.permission
  }
};

export const registerForPushNotification = async () => {
  const firebaseApp = initializeApp(firebaseConfig);

  const permission = await requestNotificationPermission();
  if (permission === "granted") {
    const messaging = getMessaging(firebaseApp);
    try {
      const token = await getToken(messaging, { vapidKey: "BMtr4_ys23Ahv2L-t6ZN-WdaNwfMio46jVw18nSzgrZCkc5kZ2ZaLA-h3qdpvpTOFRWitb9gFco9_1Yn4w4SWnc" });
      if (token) {
        console.log("FCM Token:", token);
        // Send the token to your server to manage push subscriptions.

        // Add an on-message listener for foreground notifications
        onMessage(messaging, (payload) => {
          console.log("Message received in foreground:", payload);
          if (payload.notification) {
            const { title, body } = payload.notification;
            new Notification(title, { body });
          }
        });

      } else {
        console.warn("No FCM registration token available.");
      }
    } catch (error) {
      console.error("Error retrieving FCM token:", error);
    }
  }
};